import React, { useEffect, useRef, useState } from 'react'
import Autocomplete from "react-google-autocomplete";
import Geocode from "react-geocode";
import { postData } from '../../Service/ApiMethod';
import { COMPANY_LIST } from '../../Service/service';
import AWS from 'aws-sdk';
// import ReactGoogleAutocomplete from 'react-google-autocomplete';
import { useTranslation } from "react-i18next";
import { lang } from '../../lang';
 
const AddCompany = (props) => { 
  const [ln,setLn] = useState(props?.lag) 
  const upcomp = props?.upcomp
  const [companyWebsite, setCompanyWebsite] = useState('');
  // const [companyLocation, setCompanyLocation] = useState();
  // const [companyImage, setCompanyImage] = useState();
  const [aboutCompany, setAboutCompany] = useState();
  const [newCompany, setNewCompany] = useState();
  const [workLocation, setWorkLocation] = useState('');
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [imageURL, setImageURL] = useState();


  const setPopupClose = props?.setPopupClose
  const ref = useRef(null);
  useOutsideAlerter(ref);
  const { t } = useTranslation()



  const postCompany = async () => {
    const catObj = {
      company_name: newCompany,
      company_image: `${imageURL}`,
      company_location: workLocation,
      about_company: aboutCompany,
      company_website: companyWebsite,
    };
console.log(catObj,"sssssssssssssssssssaaaaaaa")
    if (!newCompany) {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.FinalFinal["Please Enter Company Name"]:"");
    } else if (!workLocation) {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.MyProfile["Company Location"]:"");
    } 
    else if (!aboutCompany) {
      alert("Enter few words about company ");
    } 
    // else if (!companyWebsite) {
    //   alert("Enter company website ");
    // } 
    // else if (!companyWebsite.startsWith('https://')) {
    //   alert('Please enter a valid HTTPS URL.');
    // }
    // else if (catObj?.company_image == "undefined") {
    //   alert("Upload your company image");
    // } 



    else {
      await postData(catObj, COMPANY_LIST)
        .then((response) => response.json())
        .then((data) => {
          if (data?.error_message) {
            if(data?.error_message == "This Company already exist"){
              alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["This Company already exist"]:"")
            }else{
              alert(data?.error_message);
            }
            
          } else {
            // setAddCompany(false);
            setPopupClose(false)
            props?.setUpComp(!upcomp)
            alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["New Company added sucessfully!"]:"")

          }
          try {
            console.log(data);
          } catch (err) {
            console.log("error hgappended", err);
            // setError(err.message, "email already exists");
            // alert("Eoorrror", err);
          }
        });
    }
  };




  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          // props?.closeModalWrtOutsideClick();
          setPopupClose && setPopupClose(false)
        }
      }

      document.addEventListener("mousedown", handleClickOutside);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const GOOGLE_PLACES_API_KEY = 'AIzaSyAn7_5pFRSJ_i1lbbiitBzZinnYY7VTGxk';

  // const handleLocationChange = (e) => {
  //   setWorkLocation(e.target.value);
  //   // enteredLocation()
  // };


  const handlePlaceSelect = (place) => {
    enteredLocation(place)
    setWorkLocation(place.formatted_address);
    console.log(place?.geometry?.location);


  };

  // Geocode.setApiKey("AIzaSyAn7_5pFRSJ_i1lbbiitBzZinnYY7VTGxk");
  const enteredLocation = (place) => {

    Geocode.fromAddress(place).then(
      (response) => {
        const { lat, lng } = response?.results[0]?.geometry?.location;
        console.log(lat, lng, "lat lng ");
        setLatitude(lat);
        setLongitude(lng);



      },

      (error) => {
        console.error(error);
      }
    );
  };

  console.log("latitude", latitude, longitude)

  const handleRecruiterImage = (e) => {
   if(e.target.files[0]?.type == "image/png" || e.target.files[0]?.type == "image/jpg"){
    let s3 = new AWS.S3({
      accessKeyId: 'AKIA2GWTBVL6WX6U75ZC',
      secretAccessKey: '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',
      region: 'eu-central-1'
    });

    const params = {
      Bucket: 'catzapp-dev',
      Key: e.target.files[0]?.name,
      Body: e.target.files[0],
      ContentType: e.target.files[0]?.type || 'image/png',
      ACL: 'public-read'
    };

    s3.upload(params, (err, data) => {
      if (err) {
        console.log(err);
      } else {
        console.log(`File uploaded successfully. ${data?.Location}`);
        setImageURL(data?.Location)
      }
    })
   }
  }

  console.log("imageURL", imageURL)


  // const handlePlaceSelected = (place) => {
  //   setWorkLocation(place?.formatted_address);
  //   enteredLocation()
  //   console.log(place , "place")
  // };
  console.log("workLocation", workLocation)

  return ( 
    <div className="blur-screen-full-area inner-modal flex-center " >
      <div className="form-container company-form" style={{ zIndex: '1' }}>
        <div style={{ display: 'flex', justifyContent: "space-between" }}>
          <span className="text-bold popup-heading fs-15 mb-3">{t('Add New Company')}</span>
          <img style={{ background: 'red', width: '20px', height: '20px', borderRadius: '50%', margin: '-12px', cursor: 'pointer' }} src='../images/cross.png' alt='hello' onClick={() => {
            setPopupClose(false)
          }
          } />
        </div>

        <input
          required=""
          type="text"
          placeholder={t("Enter Company Name")}
          class="input-text w-100 mb-2"
          onChange={(e) => {
            setNewCompany(e.target.value)
          }}
        />
        <input
          required=""
          type="text"
          placeholder={lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["Enter Company Website"]:""}
          class="input-text w-100 mb-2"
          // value={props?.website}
          onChange={((e) => {
            setCompanyWebsite(e.target.value)
          })}
        />
        <div style={{}}>
        <Autocomplete
 
          // required="" }}
          // value={workLocation}
          defaultValue={workLocation}
          apiKey={GOOGLE_PLACES_API_KEY}
          onPlaceSelected={handlePlaceSelect}
          className="input-text w-100 mb-2"
          placeholder={t('Enter Company Location')}
          onChange={(e) => {
            // console.log(e.target.value,"dddddd");
            setWorkLocation(e.target.value);
          }}

        />
        </div>
        <input
          required=""
          type="text"
          placeholder={lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["Enter About Your Company"]:""}
          class="input-text w-100 mb-2"

          onChange={(e) => {

            setAboutCompany(e.target.value)
          }}
        />

        <input
          type="file"
          accept="image/*"
          // style="display: none;"
          placeholder="Upload Your background image "
          className="input-text w-100 mb-2 companyIa"

          onChange={(e) => {
            var inputFi = document.querySelector('.companyIa');
            var filePath = e.target.value.toLowerCase();
            var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
            if (!allowedExtensions.exec(filePath)) {
                alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth['Please upload file having extensions .jpeg/.jpg/.png only.']:"");
                inputFi.value = ""
                return false
            }else{
              handleRecruiterImage(e)
            }
            

          }}

        // defalutValue={prefilledData?.imageURL}

        />
{
            imageURL == null? null:(<img src={imageURL} style={{width:100,height:100}}/>)
          }
        <div className=" flex-center">
          <button
            type="submit"
            onClick={() => {
              postCompany()
            }}
            class="theme-btn px-5 text-center w-75"
            style={{  }}
          >
            {lang && Object.keys(lang).length > 0 ? lang[ln]?.Home['Add']:""}
          </button>
        </div>
      </div>
    </div>
  )
}

export default AddCompany